<template>
  <div>
    <v-dialog v-model="showStudioDataDialog" width="100vw">
      <v-card>
        <div class="modal-header header-div">
          <v-spacer></v-spacer>
          <v-btn @click="closeModal" flat icon size="x-small">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <StudioData @save-chart="handleChartSavedStudio" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-form>
      <ScreenLoader v-if="showLoader == true"></ScreenLoader>
      <v-row
        class="dashboard-top"
        no-gutters
        v-else-if="
          Array.isArray(this.dashboardsArr) && this.dashboardsArr.length != 0
        "
      >
        <v-col cols="12" md="6" class="pa-0">
          <label for="">Select Saved Dashboard</label>
          <v-select
            v-model="dashboard"
            variant="solo"
            class="custom-field"
            :items="dashboardName"
            item-text="Name"
            @update:modelValue="() => changeDashboard()"
            placeholder="Select Dashboard"
            hide-details
          >
          </v-select>
        </v-col>

        <v-col cols="12" md="6" class="pa-0 d-flex justify-end">
          <v-btn
            variant
            class="save-btn dashboard-btn text-none"
            @click="dashboardCreate()"
          >
            <img :src="addDashboard" alt="add" />
            <h6>Create Dashboard</h6>
          </v-btn>
        </v-col>
      </v-row>
      <div
        v-else-if="
          !Array.isArray(this.dashboardsArr) || this.dashboardsArr.length == 0
        "
        class="text-center pt-5"
      >
        <h4>No dashboard available</h4>
      </div>
      <div v-else-if="timeoutMessage != ''" class="timeout">
        <div class="text-center">
          {{ timeoutMessage }}
          <v-icon
            flat
            @click="getSavedDashboards()"
            color="blue-darken-3"
            icon="mdi-reload"
            size="large"
          ></v-icon>
        </div>
      </div>
      <ChartLoaders v-if="showChartsLoader == true"></ChartLoaders>
      <BoardSelected v-else-if="showDashboard" ref="childComponentRef" @dashboard-reload="reloadAfterDelete" @dashboard-name-update="nameUpdate"/>
      <div
        class="pb-3 mt-4 chart-selection-wrap inputs-wrap"
        v-else-if="showInputs && Array.isArray(chartTypes) && chartTypes.length != 0"
      >
      <v-row no-gutters>
        <v-col cols="12" md="6">
          <h6 class="main-heading mb-2">Create Dashboard</h6>
        </v-col>
        <v-col cols="12" md="6" class="d-flex justify-end" v-if="isAdmin">
          <div class="switch-div dashboard-switch-div mb-2">
            <label for="">Access Level:</label>
            <v-switch v-model="isPublic" color="info" inset :label="dashboardAccessLevel"
              @change="handleToggleChange" hide-details></v-switch>
          </div>
        </v-col>
      </v-row>
        <v-row no-gutters>
          <v-col cols="12" class="pa-0 pb-5">
            <label for="">Enter Dashboard Name</label>
            <v-text-field
              v-model="name"
               variant="solo"
            class="custom-field"
              required
              placeholder="Enter Name"
              hide-details
              outlined
            ></v-text-field>
          </v-col>
          
          <v-col cols="12" md="6" class="pa-0">
            <label for="">Select Saved Plot</label>
            <v-select
              clearable
               variant="solo"
            class="custom-field"
              v-model="chart_one"
              :items="chartTypesName"
              item-value="ID"
              item-text="Name"
              placeholder="Select Plot"
              @update:modelValue="() => chartTypeChange(chart_one)"
            >
            </v-select>
          </v-col>
          <v-col cols="12" md="6" class="pa-0 pl-md-2 py-md-0">
            <label for="">Select Saved Plot</label>
            <v-select
              clearable
               variant="solo"
            class="custom-field"
              v-model="chart_two"
              :items="chartTypesName"
              item-value="ID"
              item-text="Name"
              placeholder="Select Plot"
              @update:modelValue="() => chartTypeChange(chart_two)"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6" class="pa-0">
            <label for="">Select Saved Plot</label>
            <v-select
              clearable
               variant="solo"
            class="custom-field"
              v-model="chart_three"
              :items="chartTypesName"
              item-value="ID"
              item-text="Name"
              placeholder="Select Plot"
              @update:modelValue="() => chartTypeChange(chart_three)"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6" class="pa-0 pl-md-2 py-md-0">
            <label for="">Select Saved Plot</label>
            <v-select
              clearable
               variant="solo"
            class="custom-field"
              v-model="chart_four"
              :items="chartTypesName"
              item-value="ID"
              item-text="Name"
              placeholder="Select Plot"
              @update:modelValue="() => chartTypeChange(chart_four)"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6" class="pa-0">
            <label for="">Select Saved Plot</label>
            <v-select
              clearable
               variant="solo"
            class="custom-field"
              v-model="chart_five"
              :items="chartTypesName"
              item-value="ID"
              item-text="Name"
              placeholder="Select Plot"
              @update:modelValue="() => chartTypeChange(chart_five)"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6" class="pa-0 pl-md-2 py-md-0">
            <label for="">Select Saved Plot</label>
            <v-select
              clearable
               variant="solo"
            class="custom-field"
              v-model="chart_six"
              :items="chartTypesName"
              item-value="ID"
              item-text="Name"
              placeholder="Select Plot"
              @update:modelValue="() => chartTypeChange(chart_six)"
            ></v-select>
          </v-col>
        </v-row>
        <div class="save-dash">
          <v-btn
          v-if="showInputs"
            block
            flat
            @click="openDialog()"
            :disabled="isSaveDisabled"
            class="save-btn text-none"
          >
            <img :src="saveDashboard" alt="save_dashboard" />
            <span>Save Dashboard Settings</span></v-btn
          >
        </div>
      </div>
      <div
        v-else-if="!Array.isArray(chartTypes) || chartTypes.length == 0"
        class="no-test-div text-center"
      >
        <h4>
          No charts found. <br />
          please create charts first from
          <router-link to="/Fluidsdata-studio" exact>
            <span>Studio page</span>
          </router-link>
        </h4>
      </div>
      <div v-else-if="timeoutMessageCharts != ''" class="no-asset-div timeout">
        <div class="text-center">
          {{ timeoutMessageCharts }}
          <v-icon
            flat
            @click="getSavedCharts()"
            color="blue-darken-3"
            icon="mdi-reload"
            size="large"
          ></v-icon>
        </div>
      </div>
    </v-form>
    <v-snackbar v-model="showAlert" color="#E53535" timeout="5000">
      Error : {{ errorMessage }}
    </v-snackbar>
    <ConfirmDashboard
      ref="childComponent"
      @open-dialog="openDialog"
      :selectedChartIds="selectedChartIds"
      :name="name"
      :isPublic="isPublic"
      @dashboard-saved="reloadDashboards"
    />
  </div>
</template>

<script>
import axios from "axios";
import api from "../../../axiosInterceptor";
import ScreenLoader from "../Loaders/ScreenLoader.vue";
import ChartLoaders from "../Loaders/ChartLoaders.vue";
import BoardSelected from "./BoardSelected.vue";
import ConfirmDashboard from "./ConfirmDashboard.vue";
import StudioData from '../FluidsDataStudioTwo/StudioData.vue';
import { mapGetters } from "vuex";
export default {
  components: { ScreenLoader, ChartLoaders, BoardSelected, ConfirmDashboard, StudioData },
  name: "ChartInputs",
  data() {
    return {
      dashboardsArr: [],
      selectedChartIds: [],
      dashboardName: [],
      name: "",
      chart_one: null,
      chart_two: null,
      chart_three: null,
      chart_four: null,
      chart_five: null,
      chart_six: null,
      chartTypes: [],
      chartTypesName: [],
      loading: false,
      showAlert: false,
      errorMessage: "",
      dashboard: null,
      showLoader: true,
      showChartsLoader: false,
      timeoutMessage: "",
      timeoutMessageCharts: "",
      showDashboard: false,
      saveDashboard: require("../../../assets/Images/Dashboard/save.png"),
      addDashboard: require("../../../assets/Svg/add-dash.svg"),
      showInputs: true,
      isPublic: false,
      showStudioDataDialog: false,
      dashboardAccessLevel: "private"
    };
  },
  computed: {
    ...mapGetters("tenantId", ["getUser"]),
    isAdmin() {
      return this.getUser && (this.getUser.role === "Administrator" || this.getUser.role === "SuperAdmin");
    },
    isSaveDisabled() {
      return (
        !this.name ||
        !(
          this.chart_one ||
          this.chart_two ||
          this.chart_three ||
          this.chart_four ||
          this.chart_five ||
          this.chart_six
        )
      );
    },
  },
  methods: {
    handleToggleChange() {
      this.dashboardAccessLevel = this.isPublic ? "public" : "private";
    },
    openDialog() {
      if (this.$refs.childComponent) {
        this.$refs.childComponent.openDialog();
      } else {
        console.error("Child component not available");
      }
    },
    handleChartSavedStudio() {
      this.closeModal();
      this.getSavedCharts();
    },
    getSavedCharts() {
      this.showChartsLoader = true;
      this.timeoutMessageCharts = "";
      api
        .get("public/api/charts")
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            this.chartTypes = response.data.data.charts;
            this.chartTypesName = [
              ...this.chartTypes.map((chart) => chart.Name),
              "+ Create Plot"
            ];
          }
          else if (response && response.data && response.data.message) {
            this.timeoutMessageCharts = response.data.message;
          }
          else {
      this.timeoutMessageCharts = "Error in fetching charts";
    }
        })
        .catch((error) => {
          this.timeoutMessageCharts = error;
        })
        .finally(() => {
          this.showChartsLoader = false;
        });
    },

    getSavedDashboards() {
      this.showLoader = true;
      this.timeoutMessage = "";
      api
        .get("public/api/dashboards")
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            this.dashboardsArr = response.data.data.dashboards;
            this.dashboardName = response.data.data.dashboards.map(
              (dashboard) => dashboard.name
            );
          }
          else if (response && response.data && response.data.message) {
            this.timeoutMessage = response.data.message;
          }
          else {
      this.timeoutMessage = "Error in fetching dashboards";
    }
        })
        .catch((error) => {
          this.timeoutMessage = error;
        })
        .finally(() => {
          1;
          this.showLoader = false;
        });
    },

    updateSelectedChartIds(chartId) {
      const index = this.selectedChartIds.indexOf(chartId);
      if (index === -1) {
        this.selectedChartIds.push(chartId);
      } else {
        this.selectedChartIds.splice(index, 1);
      }
    },



















    chartTypeChange(selectedChart) {
      this.selectedChartIds = [];

      const updateSelectedChart = (chart) => {
        const selected = this.chartTypes.find(c => c.Name === chart);
        if (selected) {
          this.updateSelectedChartIds(selected.ID);
        }
      };

      updateSelectedChart(this.chart_one);
      updateSelectedChart(this.chart_two);
      updateSelectedChart(this.chart_three);
      updateSelectedChart(this.chart_four);
      updateSelectedChart(this.chart_five);
      updateSelectedChart(this.chart_six);

      let availableCharts = this.chartTypes.filter(chart => !this.selectedChartIds.includes(chart.ID));
      this.chartTypesName = availableCharts.map(chart => chart.Name).concat("+ Create Plot");

      if (selectedChart === "+ Create Plot") {
        this.openStudioDataDialog();
        if(selectedChart === this.chart_one) {
          this.chart_one = null;
        }
        if(selectedChart === this.chart_two) {
          this.chart_two = null;
        }
        if(selectedChart === this.chart_three) {
          this.chart_three = null;
        }
        if(selectedChart === this.chart_four) {
          this.chart_four = null;
        }
        if(selectedChart === this.chart_five) {
          this.chart_five = null;
        }
        if(selectedChart === this.chart_six) {
          this.chart_six = null;
        }
      }
    },

    openStudioDataDialog() {
      this.showStudioDataDialog = true;
    },

    closeModal() {
      this.showStudioDataDialog = false;
    },
    

    changeDashboard() {
      const selectedDashboard = this.dashboardsArr.find(
        (dashboard) => dashboard.name === this.dashboard
      );

      if (selectedDashboard) {
        localStorage.setItem("dashboard", selectedDashboard.name);
        this.showInputs = false;
        this.showDashboard = true;
        if (this.showDashboard && this.$refs.childComponentRef) {
          this.$refs.childComponentRef.changeDashboard()
        }
      }
    },
    dashboardCreate() {
      this.showDashboard = false;
      this.showInputs = true;
      this.dashboard= null;
      this.chart_one = null;
      this.chart_two = null;
      this.chart_three = null;
      this.chart_four = null;
      this.chart_five = null;
      this.chart_six = null;
    },
    reloadDashboards() {
      this.getSavedDashboards();
      this.getSavedCharts();
      this.name = "";
      this.chart_one = null;
      this.chart_two = null;
      this.chart_three = null;
      this.chart_four = null;
      this.chart_five = null;
      this.chart_six = null;
      this.showDashboard = true;
      this.showInputs = false;
    },
     reloadAfterDelete() {
      this.getSavedDashboards();
      this.getSavedCharts();
      this.dashboard = null;
      this.showDashboard = false;
      this.showInputs = true;
    },
    nameUpdate() {
      const name_update = localStorage.getItem("dashboard");
      this.dashboard = name_update;
      this.getSavedDashboards();
    }
  },
  mounted() {
    this.getSavedDashboards();
    this.getSavedCharts();
    const defaultDashboard = localStorage.getItem("defaultDashboard");
    if (defaultDashboard) {
      this.showDashboard = true;
      this.dashboard = defaultDashboard;
      localStorage.setItem("dashboard", this.dashboard);
    }
    else {
      this.showInputs = true;
    }
  },
};
</script>